var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCodeIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  fill: "none",
  viewBox: "0 0 16 14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.333 10.333 14.667 7l-3.334-3.333m-6.666 0L1.333 7l3.334 3.333M9.333 1 6.667 13"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCodeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/codeIcon.bf52085b8de7084643903e6fb2c5b0f1.svg";